export enum TrackingEvent {
  ReportListOpen = `Report list - open`,
  ReportSaved = `Report saved`,
  ReportSavedAsNew = `Report saved as new`,
  ResetState = `Reset state`,
  LaunchTour = `Launch tour`,

  // Boards specific events
  ReturnToBoards = `Return to Boards`,
  StartSave = `Start Save`,
  StartReportDuplicate = `Start Report Duplicate`,
  StartReportRename = `Start Report Rename`,
  StartReportDelete = `Start Report Delete`,
}

export enum SaveTypeTrackingProperty {
  New = `New`,
  Duplicated = `Duplicated`,
  Existing = `Existing`,
  Renamed = `Renamed`,
}
